import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatSort, Sort } from "@angular/material/sort";
import { Product, ProductDTO } from '../../../commons/models/product';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Observable } from 'rxjs';
import { PAGE_SIZE_OPTIONS } from '../../../helpers/table.helper';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-products-list',
  templateUrl: './products-list.component.html',
  styleUrls: ['./products-list.component.scss']
})
export class ProductsListComponent {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  @Input() products: ProductDTO[];
  @Input() selectedProducts: Product[];
  @Input() defaultFilters: any;

  @Input() total: Observable<number>;
  @Input() displayedColumns = ["photo", "name", "type", "price", "actions"];

  @Input() canAdd: boolean;
  @Input() canEdit: boolean;
  @Input() canSelect: boolean;

  @Output() onLoad: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSortChange: EventEmitter<Sort> = new EventEmitter<Sort>();
  @Output() onPageChange: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();
  @Output() onFilterChange: EventEmitter<any> = new EventEmitter<any>();

  @Output() onSelectProduct: EventEmitter<Product> = new EventEmitter<Product>();
  @Output() onAddProduct: EventEmitter<any> = new EventEmitter<any>();
  @Output() onEditProduct: EventEmitter<Product> = new EventEmitter<Product>();
  @Output() onAddSelectedProduct: EventEmitter<Product> = new EventEmitter<Product>();
  @Output() onRemoveSelectedProduct: EventEmitter<Product> = new EventEmitter<Product>();
  @Output() onDeleteProduct: EventEmitter<Product> = new EventEmitter<Product>();

  pageSizeOptions = PAGE_SIZE_OPTIONS;

  constructor() {
    // console.log(this.products);
  }

  ngAfterViewInit() {
    if (this.sort) {
      this.sort.sortChange.subscribe((sort) => {
        this.onSortChange.emit(sort);
      });
    }

    if (this.paginator) {
      this.paginator.page.subscribe((pageEvent) => {
        this.onPageChange.emit(pageEvent);
      });
    }
  }


  isSelected(user: Product): boolean {
    return this.selectedProducts.map(obj => obj.name).includes(user.name);
  }

  addProduct() {
    this.onAddProduct.emit();
  }

  addSelectedUser(user: Product) {
    this.onAddSelectedProduct.emit(user);
  }

  removeSelectedUser(user: Product) {
    this.onRemoveSelectedProduct.emit(user);
  }

  editProduct(product: Product) {
    this.onEditProduct.emit(product);
  }

  deleteProduct(product: Product) {
    this.onDeleteProduct.emit(product);
  }

  selectUser(user: Product) {
    this.onSelectProduct.emit(user);
  }

  onFilter(filters: any) {
    this.paginator.firstPage();
    this.onFilterChange.emit(filters);
  }

  isAllSelected() {
    const numSelected = this.selectedProducts.length;
    const numRows = this.products.length;
    return numSelected === numRows;
  }


}
